import React from "react";
import classnames from "classnames";
import Icon from "basic-elements/Icon";
import addPV from "utils/add-pv.js";
import styles from "./FeaturePagesMenu.module.scss";

import useSiteHeaderEN from "hooks/use-site-header-en.js";
import useSiteHeaderES from "hooks/use-site-header-es.js";
import useSiteHeaderPT from "hooks/use-site-header-pt.js";
import useSiteHeaderRU from "hooks/use-site-header-ru.js";
import useSiteHeaderFR from "hooks/use-site-header-fr.js";
import useSiteHeaderDE from "hooks/use-site-header-de.js";
import useSiteHeaderCN from "hooks/use-site-header-cn.js";
import useSiteHeaderTW from "hooks/use-site-header-tw.js";
import useSiteHeaderJP from "hooks/use-site-header-jp.js";

import menuListData from "./FeaturePagesMenuData.json";

const menuDataEnum = {
  "1": useSiteHeaderEN,
  "2": useSiteHeaderES,
  "3": useSiteHeaderPT,
  "4": useSiteHeaderRU,
  "5": useSiteHeaderFR,
  "6": useSiteHeaderDE,
  "7": useSiteHeaderCN,
  "8": useSiteHeaderTW,
  "9": useSiteHeaderJP
};

const FeaturePagesMenu = ({ siteId, isHomepage }) => {
  const [tabsList] = React.useState(menuDataEnum[siteId]().categories);
  const [activeSubmenu, setActiveSubmenu] = React.useState(tabsList[0].slug);

  if (!tabsList) return null;
  return (
    <div className={styles.featurePagesMenu}>
      <div className={styles.featurePagesMenu__tabs}>
        {tabsList.map(i => {
          if (!menuListData[siteId][i.slug]) return null;
          return (
            <div
              key={i.title}
              onMouseEnter={() => setActiveSubmenu(i.slug)}
              className={classnames(styles.tab, i.slug === activeSubmenu ? styles.active : null)}
            >
              <Icon name={i.slug} size={24} className={styles.tab__icon} />
              <span className={styles.tab__title}>{i.title}</span>
              <Icon name="arrow-down" className={styles.tab__arrow} />
            </div>
          );
        })}
      </div>
      <div className={styles.featurePagesMenu__content}>
        {!!menuListData[siteId][activeSubmenu] &&
          menuListData[siteId][activeSubmenu].map(i => {
            if (isHomepage) {
              return (
                <a
                  className={styles.pageLink}
                  key={i.title}
                  href={i.url}
                  onClick={e =>
                    addPV(e, "trackEvent", {
                      category: "homePage-function",
                      action: "functionEnter_click",
                      label: `up|feature|${
                        tabsList.filter(i => i.slug === activeSubmenu)[0].title
                      }|${i.title}`,
                      path: i.url,
                      openInNewTab: false
                    })
                  }
                >
                  {i.title}
                </a>
              );
            }
            return (
              <a className={styles.pageLink} key={i.title} href={i.url}>
                {i.title}
              </a>
            );
          })}
      </div>
    </div>
  );
};

export default FeaturePagesMenu;
